export interface CampoJuegoTipoIluminacionJSON {
  cjti_id: string | null;
  cjti_descripcion: string;
  cjti_activo: boolean;
}

export class CampoJuegoTipoIluminacion {
  protected constructor(private id: string | null, private descripcion: string, private activo: boolean) {}

  static createFrom(id: string | null, descripcion: string, activo: boolean) {
    return new this(id, descripcion, activo);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: CampoJuegoTipoIluminacion) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: CampoJuegoTipoIluminacionJSON) {
    return CampoJuegoTipoIluminacion.createFrom(entity.cjti_id, entity.cjti_descripcion, entity.cjti_activo);
  }

  toJSON(): CampoJuegoTipoIluminacionJSON {
    return {
      cjti_id: this.getId(),
      cjti_descripcion: this.getDescripcion(),
      cjti_activo: this.getActivo(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getDescripcion(): string {
    return this.descripcion;
  }

  getActivo(): any {
    return this.activo;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setDescripcion(value: string): void {
    this.descripcion = value;
  }

  setActivo(value: any): void {
    this.activo = value;
  }
}
